import * as React from 'react';

import styled from '@mint-lib/styled';

import { CollapseI, createBreadcrumb } from '../../common/Breadcrumb/utils.jsx';

export interface BreadcrumbsProps {
  /**
  
   */
  children: React.ReactNode;
  /**
   */
  separator?: React.ReactNode | string;
  /**
   */
  collapse?: CollapseI;
}

const Breadcrumbs = ({
  separator = '/',
  collapse = {},
  children: items,
}: BreadcrumbsProps) => {
  const ref = React.useRef(null);

  const children = createBreadcrumb({
    items,
    collapse,
    separator,
    ref,
  });

  return <StyledBreadcrumbs>{children}</StyledBreadcrumbs>;
};

export default Breadcrumbs;

const StyledBreadcrumbs = styled('div')`
  display: flex;
  align-items: center;
`;
